<!--
 * @Author: M.D.
 * @Date: 2019-12-30 17:00:17
 * @LastEditors  : M.D.
 * @Description: 资讯列表
 * @Remarks:
 -->
<template>
  <div class="news-l-o-w">
    <div class="news-l-ctn-w">
      <div class="news-type-filter-w">
        <list-inner-filter
          @fVal="innerFilterChg"
          :filterArr="newsFilter"
        ></list-inner-filter>
      </div>
      <!-- list -->
      <div class="news-list-o-w">
        <ul class="nl-ul">
          <li
            class="nl-li"
            @click="goNewsDetail(i)"
            v-for="i in dataList"
            :key="i.id"
          >
            <div class="nl-li-l">
              <div class="nl-l-img-w">
                <img
                  :src="tImgUrl(i.pics.split(',')[0])"
                  alt=""
                  :onerror="errImgDefault"
                />
              </div>
            </div>
            <div class="nl-li-r">
              <div class="nl-li-r-title">{{ i.title }}</div>
              <div class="nl-li-r-brief">{{ i.brief }}</div>
              <div class="nl-li-r-date">时间：{{ i.releaseTime }}</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="news-ls-page-w" v-if="dataList.length !== 0">
      <el-pagination
        class="news-ls-page"
        background
        layout="prev, pager, next"
        @prev-click="prePage"
        @next-click="nxtPage"
        @current-change="curChg"
        :current-page="curPage"
        :page-size="pageSize"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import ListInnerFilter from '@/components/list-inner-filter'
import API from '@/api/api'

export default {
  props: {},
  data() {
    return {
      innerFilter: null,

      curPage: 1,
      pageSize: 10,
      dataList: [],

      total: 10,

      newsFilter: [
        { name: '推荐', key: '', isSel: 1 },
        {
          name: '行业新闻',
          key: 1,
          isSel: 0,
        },
        {
          name: '财税金融',
          key: 2,
          isSel: 0,
        },
        {
          name: '财务专栏',
          key: 3,
          isSel: 0,
        },
      ],
    }
  },
  computed: {},
  created() {
    // this.initNewsList()
  },
  mounted() {},
  activated() {},
  deactivated() {},
  watch: {
    curPage() {
      this.updateList()
    },
  },

  methods: {
    innerFilterChg(v) {
      this.updateList()
    },
    async updateList() {
      const type = await this._.find(this.newsFilter, { isSel: 1 })
      const query = {
        currentPage: this.curPage,
        pageSize: this.pageSize,
        type: type.key,
        sortField: 'disp_order',
        sortOrder: 'Asc',
      }
      const re = await API.getNewsListByType(query)
      this.dataList = re.data.result.records
      this.total = Number(re.data.result.total)
    },
    goNewsDetail(i) {
      this.$router.push({ name: 'news-detail', params: { newsId: i.id } })
    },
    curChg(v) {
      this.curPage = v
    },
    prePage(v) {
      this.curPage = v
    },
    nxtPage(v) {
      this.curPage = v
    },
  },
  components: {
    ListInnerFilter,
  },
}
</script>

<style lang="stylus" scoped>
.news-l-o-w {
  width:1200px;
  margin:auto;
  .news-l-ctn-w {
    .news-type-filter-w {
      background-color: #ffffff;
    }

    .news-list-o-w {
      margin-top: 20px;
      min-height: 300px;
      background-color: #ffffff;

      .nl-ul {
        padding: 20px 26px;

        .nl-li {
          display: flex;
          height: 200px;
          border-bottom: 2px solid #dddddd;

          .nl-li-l {
            flex: 0 0 220px;

            .nl-l-img-w {
              img-wrapper();
              margin-top: 18px;
              max-height: 170px;

              img {
                inner-img-ww();
              }
            }
          }

          .nl-li-r {
            flex: 1 1 auto;
            margin: 14px 24px;
            position: relative;

            .nl-li-r-title {
              font-size: 24px;
            }

            .nl-li-r-brief {
              font-size: 16px;
              margin: 18px 0 22px;
              line-height: 20px;
              color: #999999;
            }

            .nl-li-r-date {
              position: absolute;
              bottom: 0;
              left: 0;
              font-size: 18px;
              color: #999999;
            }
          }
        }
      }
    }
  }

  .news-ls-page-w {
    padding: 10px 0 30px;
    background-color: #ffffff;
    display: flex;
    justify-content: center;
    .news-ls-page {
      rightBottom();
    }
  }
}
</style>
